import { Inject, PLATFORM_ID, ɵɵdefineInjectable, ɵɵinject, Injectable, ElementRef, Input, HostListener, Directive, NgModule } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/router';
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
class SimpleSmoothScrollOption {
    constructor(option) {
        /**
         * EasingFunctions - from https://gist.github.com/gre/1650294
         */
        this.EasingFunctions = {
            // no easing, no acceleration
            linear: (t) => { return t; },
            // accelerating from zero velocity
            easeInQuad: (t) => { return t * t; },
            // decelerating to zero velocity
            easeOutQuad: (t) => { return t * (2 - t); },
            // acceleration until halfway, then deceleration
            easeInOutQuad: (t) => { return t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t; },
            // accelerating from zero velocity 
            easeInCubic: (t) => { return t * t * t; },
            // decelerating to zero velocity 
            easeOutCubic: (t) => { return (--t) * t * t + 1; },
            // acceleration until halfway, then deceleration 
            easeInOutCubic: (t) => { return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1; },
            // accelerating from zero velocity 
            easeInQuart: (t) => { return t * t * t * t; },
            // decelerating to zero velocity 
            easeOutQuart: (t) => { return 1 - (--t) * t * t * t; },
            // acceleration until halfway, then deceleration
            easeInOutQuart: (t) => { return t < .5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t; },
            // accelerating from zero velocity
            easeInQuint: (t) => { return t * t * t * t * t; },
            // decelerating to zero velocity
            easeOutQuint: (t) => { return 1 + (--t) * t * t * t * t; },
            // acceleration until halfway, then deceleration 
            easeInOutQuint: (t) => { return t < .5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t; }
        };
        this.duration = option.duration || 800;
        this.offset = option.offset || 0;
        this.easing = this.EasingFunctions[option.easing] || this.EasingFunctions['easeInOutQuad'];
    }
}
let SimpleSmoothScrollService = class SimpleSmoothScrollService {
    constructor(platformId) {
        this.platformId = platformId;
    }
    smoothScroll(height, opt, el = document.documentElement) {
        if (isPlatformBrowser(this.platformId)) {
            const option = new SimpleSmoothScrollOption(opt);
            const duration = option.duration;
            const begin = (window.pageYOffset || el.scrollTop) - (el.clientTop || 0);
            const t = 10;
            const tick = 1 / (duration / t);
            height += option.offset;
            const distance = height - begin;
            if (distance == 0)
                return;
            let time = 0;
            let y, current;
            let s = setInterval(function () {
                y = option.easing(time);
                current = y * distance + begin;
                if (current >= height && distance > 0) {
                    current = height;
                    clearInterval(s);
                }
                if (current < height + tick && distance < 0) {
                    current = height;
                    clearInterval(s);
                }
                if (current < 0 && distance < 0) {
                    current = 0;
                    clearInterval(s);
                }
                el.scrollTo(0, current);
                time += tick;
            }, t);
        }
    }
    smoothScrollToTop(opt = {}, el = document.documentElement) {
        this.smoothScroll(0, opt, el);
    }
    smoothScrollToAnchor(opt = {}, el = document.documentElement) {
        if (isPlatformBrowser(this.platformId)) {
            let eid = window.location.hash;
            if (eid)
                eid = eid.replace('#', '');
            let target = document.getElementById(eid);
            if (target)
                this.smoothScroll(target.offsetTop - el.offsetTop, opt, el);
        }
    }
};
SimpleSmoothScrollService.ɵfac = function SimpleSmoothScrollService_Factory(t) { return new (t || SimpleSmoothScrollService)(ɵngcc0.ɵɵinject(PLATFORM_ID)); };
SimpleSmoothScrollService.ctorParameters = () => [
    { type: Object, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
SimpleSmoothScrollService.ɵprov = ɵɵdefineInjectable({ factory: function SimpleSmoothScrollService_Factory() { return new SimpleSmoothScrollService(ɵɵinject(PLATFORM_ID)); }, token: SimpleSmoothScrollService, providedIn: "root" });
SimpleSmoothScrollService = __decorate([ __param(0, Inject(PLATFORM_ID)),
    __metadata("design:paramtypes", [Object])
], SimpleSmoothScrollService);

var __decorate$1 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1 = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param$1 = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
let SimpleSmoothScrollDirective = class SimpleSmoothScrollDirective {
    constructor(el, router, smooth, platformId) {
        this.el = el;
        this.router = router;
        this.smooth = smooth;
        this.platformId = platformId;
    }
    onClick() {
        if (isPlatformBrowser(this.platformId)) {
            let container = this.container || document.documentElement;
            let eid = this.el.nativeElement.hash;
            if (eid) {
                if (this.showHash) {
                    const href = this.el.nativeElement.href;
                    const dest = new URL(href);
                    const loc = window.location;
                    if (dest.pathname == loc.pathname) {
                        // Change URL hash without page jump
                        history.pushState(null, null, href);
                    }
                }
                eid = eid.replace('#', '');
            }
            let target = document.getElementById(eid) || document.getElementById(this.scrollTo);
            if (target)
                this.smooth.smoothScroll(target.offsetTop, { duration: this.duration, easing: this.easing, offset: this.offset }, container);
            return false;
        }
    }
};
SimpleSmoothScrollDirective.ɵfac = function SimpleSmoothScrollDirective_Factory(t) { return new (t || SimpleSmoothScrollDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Router), ɵngcc0.ɵɵdirectiveInject(SimpleSmoothScrollService), ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID)); };
SimpleSmoothScrollDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: SimpleSmoothScrollDirective, selectors: [["", "SimpleSmoothScroll", ""]], hostBindings: function SimpleSmoothScrollDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function SimpleSmoothScrollDirective_click_HostBindingHandler() { return ctx.onClick(); });
    } }, inputs: { container: "container", scrollTo: "scrollTo", duration: "duration", offset: "offset", easing: "easing", showHash: "showHash" } });
SimpleSmoothScrollDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Router },
    { type: SimpleSmoothScrollService },
    { type: Object, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
__decorate$1([
    Input(),
    __metadata$1("design:type", HTMLElement)
], SimpleSmoothScrollDirective.prototype, "container", void 0);
__decorate$1([
    Input(),
    __metadata$1("design:type", String)
], SimpleSmoothScrollDirective.prototype, "scrollTo", void 0);
__decorate$1([
    Input(),
    __metadata$1("design:type", Number)
], SimpleSmoothScrollDirective.prototype, "duration", void 0);
__decorate$1([
    Input(),
    __metadata$1("design:type", Number)
], SimpleSmoothScrollDirective.prototype, "offset", void 0);
__decorate$1([
    Input(),
    __metadata$1("design:type", String)
], SimpleSmoothScrollDirective.prototype, "easing", void 0);
__decorate$1([
    Input(),
    __metadata$1("design:type", Boolean)
], SimpleSmoothScrollDirective.prototype, "showHash", void 0);
__decorate$1([
    HostListener('click'),
    __metadata$1("design:type", Function),
    __metadata$1("design:paramtypes", []),
    __metadata$1("design:returntype", void 0)
], SimpleSmoothScrollDirective.prototype, "onClick", null);
SimpleSmoothScrollDirective = __decorate$1([ __param$1(3, Inject(PLATFORM_ID)),
    __metadata$1("design:paramtypes", [ElementRef,
        Router,
        SimpleSmoothScrollService,
        Object])
], SimpleSmoothScrollDirective);

var __decorate$2 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let SimpleSmoothScrollModule = class SimpleSmoothScrollModule {
};
SimpleSmoothScrollModule.ɵfac = function SimpleSmoothScrollModule_Factory(t) { return new (t || SimpleSmoothScrollModule)(); };
SimpleSmoothScrollModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SimpleSmoothScrollModule });
SimpleSmoothScrollModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [SimpleSmoothScrollService] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SimpleSmoothScrollService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: Object, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SimpleSmoothScrollDirective, [{
        type: Directive,
        args: [{
                selector: '[SimpleSmoothScroll]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc1.Router }, { type: SimpleSmoothScrollService }, { type: Object, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, { onClick: [{
            type: HostListener,
            args: ['click']
        }], container: [{
            type: Input
        }], scrollTo: [{
            type: Input
        }], duration: [{
            type: Input
        }], offset: [{
            type: Input
        }], easing: [{
            type: Input
        }], showHash: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SimpleSmoothScrollModule, { declarations: [SimpleSmoothScrollDirective], exports: [SimpleSmoothScrollDirective] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SimpleSmoothScrollModule, [{
        type: NgModule,
        args: [{
                declarations: [SimpleSmoothScrollDirective],
                providers: [SimpleSmoothScrollService],
                exports: [SimpleSmoothScrollDirective]
            }]
    }], null, null); })();

/*
 * Public API Surface of ng2-simple-smooth-scroll
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SimpleSmoothScrollDirective, SimpleSmoothScrollModule, SimpleSmoothScrollOption, SimpleSmoothScrollService };

//# sourceMappingURL=ng2-simple-smooth-scroll.js.map